import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'rangeFilter'
})
export class RangeFilterPipe implements PipeTransform {
  transform(items: any[], field: string, min: number, max: number): any[] {
    if(!items) return [];
    if(!field) return items;
    return items.filter( it => {
      return it[field] >= min && it[field] <=max;
    });
   }
}


// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/range-filter.pipe.ts